import { Popover, Transition } from '@headlessui/react';
import { useCartDropdown } from '@lib/context/cart-dropdown-context';
import { useStore } from '@lib/context/store-context';
import useEnrichedLineItems from '@lib/hooks/use-enrich-line-items';
import Button from '@modules/common/components/button';
import LineItemOptions from '@modules/common/components/line-item-options';
import LineItemPrice from '@modules/common/components/line-item-price';
import Trash from '@modules/common/icons/trash';
import { formatAmount, useCart } from 'medusa-react';
import Link from 'next/link';
import { Fragment } from 'react';
import Badge from '@material-tailwind/react/components/Badge';
import { getBusinessName } from '@lib/util/get-business-name';

const CartDropdown = () => {
  const { cart } = useCart();
  const items = useEnrichedLineItems();
  const { deleteItem } = useStore();
  const { state, open, close } = useCartDropdown();

  const getTotalItem = () => {
    const giftCardItems = items?.filter((i) => !i.metadata?.processing_fee);
    if (giftCardItems?.length === 0) return 0;
    return giftCardItems?.map((c) => c.quantity)?.reduce((a, b) => a + b);
  };

  return (
    <>
      {true ? (
        <div className="float-right z-50 mr-1" onMouseEnter={open} onMouseLeave={close}>
          <Popover className="relative h-full">
            <Popover.Button className="h-full">
              <Link href={'/cart'} prefetch={false} className="object-cover">
                <Badge
                  content={getTotalItem()}
                  invisible={getTotalItem() === 0}
                  className="min-h-[15px] min-w-[15px] px-1 leading-[8px] !font-normal"
                >
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.05473 16.1623H8.05587C8.05683 16.1623 8.05778 16.1621 8.05873 16.1621H21.3379C21.6648 16.1621 21.9522 15.9452 22.0421 15.6309L24.9718 5.37701C25.0349 5.15595 24.9906 4.91829 24.8524 4.73481C24.7139 4.55132 24.4974 4.44336 24.2676 4.44336H6.36558L5.84201 2.08722C5.76744 1.7521 5.47027 1.51368 5.12695 1.51368H0.732421C0.327873 1.51368 0 1.84155 0 2.2461C0 2.65065 0.327873 2.97852 0.732421 2.97852H4.53949C4.63218 3.39604 7.04498 14.2538 7.18383 14.8785C6.40545 15.2168 5.85937 15.9929 5.85937 16.8945C5.85937 18.1061 6.84509 19.0918 8.05664 19.0918H21.3379C21.7424 19.0918 22.0703 18.7639 22.0703 18.3594C22.0703 17.9548 21.7424 17.627 21.3379 17.627H8.05664C7.65285 17.627 7.32421 17.2983 7.32421 16.8945C7.32421 16.4913 7.65171 16.1633 8.05473 16.1623ZM23.2965 5.90821L20.7853 14.6973H8.6441L6.69098 5.90821H23.2965Z"
                      fill="#183238"
                    />
                    <path
                      d="M7.32422 21.2891C7.32422 22.5006 8.30994 23.4863 9.52148 23.4863C10.733 23.4863 11.7187 22.5006 11.7187 21.2891C11.7187 20.0775 10.733 19.0918 9.52148 19.0918C8.30994 19.0918 7.32422 20.0775 7.32422 21.2891ZM9.52148 20.5566C9.92527 20.5566 10.2539 20.8853 10.2539 21.2891C10.2539 21.6928 9.92527 22.0215 9.52148 22.0215C9.1177 22.0215 8.78906 21.6928 8.78906 21.2891C8.78906 20.8853 9.1177 20.5566 9.52148 20.5566Z"
                      fill="#183238"
                    />
                    <path
                      d="M17.6758 21.2891C17.6758 22.5006 18.6615 23.4863 19.873 23.4863C21.0846 23.4863 22.0703 22.5006 22.0703 21.2891C22.0703 20.0775 21.0846 19.0918 19.873 19.0918C18.6615 19.0918 17.6758 20.0775 17.6758 21.2891ZM19.873 20.5566C20.2768 20.5566 20.6055 20.8853 20.6055 21.2891C20.6055 21.6928 20.2768 22.0215 19.873 22.0215C19.4693 22.0215 19.1406 21.6928 19.1406 21.2891C19.1406 20.8853 19.4693 20.5566 19.873 20.5566Z"
                      fill="#183238"
                    />
                  </svg>
                </Badge>
              </Link>
            </Popover.Button>
            <Transition
              show={state}
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel
                static
                className="z-50 hidden  absolute top-[calc(100%+1px)] right-0 bg-white border-x border-b border-gray-200 w-[382px] text-gray-900"
              >
                <div className="p-4 flex items-center justify-center">
                  <h3 className="text-large-semi">Shopping Bag</h3>
                </div>
                {cart && items?.length ? (
                  <>
                    <div className="overflow-y-scroll max-h-[402px] px-4 grid grid-cols-1 gap-y-8 no-scrollbar">
                      {items
                        .sort((a, b) => {
                          return a.created_at > b.created_at ? -1 : 1;
                        })
                        .map((item) => (
                          <div className="grid grid-cols-[122px_1fr] gap-x-4" key={item.id}>
                            <div className="w-[122px]"></div>
                            <div className="flex flex-col justify-between flex-1">
                              <div className="flex flex-col flex-1">
                                <div className="flex items-start justify-between">
                                  <div>
                                    <h3 className="text-base-regular overflow-ellipsis overflow-hidden whitespace-nowrap mr-4 w-[130px]">
                                      <Link
                                        href={`/products/${item.variant?.product?.handle}`}
                                        prefetch={false}
                                        legacyBehavior
                                      >
                                        {getBusinessName(
                                          item.metadata?.card_program as string,
                                          item.metadata?.business_name as string
                                        )}
                                      </Link>
                                    </h3>
                                    <LineItemOptions variant={item.variant} region={cart.region} />
                                    <span>Quantity: {item.quantity}</span>
                                  </div>
                                  <div className="flex justify-end">
                                    <LineItemPrice region={cart.region} item={item} style="tight" />
                                  </div>
                                </div>
                              </div>
                              <div className="flex items-end justify-between text-small-regular flex-1">
                                <div>
                                  <button
                                    className="flex items-center gap-x-1 text-gray-ada"
                                    onClick={() => deleteItem(item.id, items?.length > 1, item)}
                                  >
                                    <Trash size={14} />
                                    <span>Remove</span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                    <div className="p-4 flex flex-col gap-y-4 text-small-regular">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-700 font-semibold">
                          Subtotal <span className="font-normal">(incl. taxes)</span>
                        </span>
                        <span className="text-large-semi">
                          {formatAmount({
                            amount: cart.subtotal || 0,
                            region: cart.region,
                            includeTaxes: false,
                          })}
                        </span>
                      </div>
                      <Link href="/cart" prefetch={false} passHref>
                        <Button>Go to bag</Button>
                      </Link>
                    </div>
                  </>
                ) : (
                  <div>
                    <div className="flex py-16 flex-col gap-y-4 items-center justify-center">
                      <div className="bg-gray-900 text-small-regular flex items-center justify-center w-6 h-6 rounded-full text-white">
                        <span>0</span>
                      </div>
                      <span>Your shopping bag is empty.</span>
                      <div>
                        <Link href="/store" prefetch={false}>
                          <>
                            <span className="sr-only">Go to all products page</span>
                            <Button onClick={close}>Explore products</Button>
                          </>
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </Popover.Panel>
            </Transition>
          </Popover>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default CartDropdown;
